//Painting card
import React from 'react';
import { useNavigate } from 'react-router-dom';
import './paintingcss.css';
import LoadingSpinner from '../../utility/LoadingSpinner';

function Paintingcard({ image_url, title, id }) {
  const navigate = useNavigate();

  if (!image_url || !title) return <LoadingSpinner />;

  const handleClick = () => {
    navigate(`/painting/${id}`);
  };

  return (
    <div className="painting-card" onClick={handleClick}>
      <div className="painting-card__inner">
        <img src={image_url} alt={title} className="painting-card__inner_img" />
        {/* <h3 className="painting-card__title"
          dangerouslySetInnerHTML={{ __html: title }}
        /> */}
      </div>
    </div>
  );

}

export default Paintingcard;